import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ArtistGetProfileParametersRequest } from '@/shared/api/requests/artist/parameters/get/request';
import { artistGetProfileParameters } from '@/shared/api/requests/artist/parameters/get/request';

export const useArtistProfileParametersQuery = (
  params: ArtistGetProfileParametersRequest,
  settings?: QuerySettings<typeof artistGetProfileParameters>
) =>
  useQuery({
    queryKey: ['ArtistProfileParameters', params.profileId],
    queryFn: () =>
      artistGetProfileParameters({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
